
import { SupportAnnounce6Component } from "./SupportAnnounce6Component";
export function DetailSupportFormAnnounce6Component() {
    return (
        <SupportAnnounce6Component />
    );

}
